import React, { createContext, useState, useEffect } from "react";
import config from "config";
import { getAuthData } from "../common/helpers/AuthHelper";

const getSettingsData = async () => {
  getAuthData()
  let {token} = getAuthData()
  const response = await fetch(`${config.api.url}api/settings`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((json) => json);
  return response;
};

export const SettingContext = createContext();

export const SettingProvider = (props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getSettingsData().then(setData);
  }, []);

  if (data == null) {
    return null; // or Loading or whatever
  }

  return (
    <SettingContext.Provider value={{ settings: data }}>
      {props.children}
    </SettingContext.Provider>
  );
};
